import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
	input: {
		fontSize: '16px'
	},
	error: {
		borderBottom: `1px solid ${theme.palette.red.main}`
	},
	popupIndicator: {
		color: theme.palette.purple.main,
		"& .MuiSvgIcon-root": {
			width: 32,
			height: 32,
		}
	},
	listbox: {
		boxSizing: 'border-box',
		margin: 0,
		padding: 0,
		'& ul': {
			padding: 0,
			margin: 0,
		},
	},
	paper: {
		borderRadius: 4,
	},
	errorField: {
		marginTop: 5,
		color: theme.palette.red.main,
		textAlign: 'right',
	},
}));